import * as Sentry from '@sentry/react';

const sentryWoker = () => {
	const { protocol } = document.location;
	Sentry.init({
		dsn: protocol + '//0d2e300760b045cd836149d67159cfd3@monitor.yoyi.com.cn/5',
		tracesSampleRate: 1.0,
		environment: process.env.NODE_ENV,
		release: `dna-${process.env.NODE_ENV}`,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		integrations: [
			new Sentry.BrowserTracing(),
			new Sentry.Replay({
				blockAllMedia: true
			})
		],
	});
	const userMsgJson = localStorage.getItem('UserInfoBackUp');
	if (!!userMsgJson) {
		const userMsg = JSON.parse(userMsgJson);
		Sentry.setUser({
			id: userMsg.userId,
			email: userMsg.userName,
			ip_address: userMsg.userIp
		});
	}
};

export default sentryWoker;